module.exports = __webpack_public_path__ + "img/code.916c3fa7.png";